<template>
    <div style="text-align: center">
        <h2>เพิ่มห้องพัก</h2>
        <div class="row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>ชื่อห้องพัก</label>
            </b-col>
            <b-col sm="6" class="col-sm-6">
                <input  v-model="form.rental_name"
                        type="text" class="form-control"/>
            </b-col>
        </div>
        <div class="row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>จำนวนผู้พักอาศัย</label>
            </b-col>
            <b-col sm="6" class="col-sm-6">
                <input  v-model="form.count"
                        type="number" class="form-control"/>
            </b-col>
            <b-col sm="2" class="col-sm-2 text-left">
                <label>คน</label>
            </b-col>
        </div>

        <div class="row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>ราคาห้องพัก</label>
            </b-col>
            <b-col sm="6" class="col-sm-6">
                <input  v-model="form.rent_price"
                        type="number" class="form-control"/>
            </b-col>
            <b-col sm="2" class="col-sm-2 text-left">
                <label>บาท</label>
            </b-col>
        </div>
        <div class="row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>ค่าไฟ / หน่วย</label>
            </b-col>
            <b-col sm="6" class="col-sm-6">
                <input v-model="form.bill"
                        type="number" class="form-control"/>
            </b-col>
            <b-col sm="2" class="col-sm-2 text-left">
                <label>บาท</label>
            </b-col>
        </div>
        <div class="row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>ค่าน้ำ / คน</label>
            </b-col>
            <b-col sm="6" class="col-sm-6">
                <input v-model="form.water_price"
                       type="number" class="form-control"/>
            </b-col>
            <b-col sm="2" class="col-sm-2 text-left">
                <label>บาท</label>
            </b-col>
        </div>
        <div class="row form-group">
            <b-col sm="4" class="col-sm-4 text-right">
                <label>รายชื่อ ผู้พักอาศัย</label>
            </b-col>
            <b-col sm="6" class="col-sm-6">
                <multiselect
                        v-model="form.employee"
                        :options="optionEmployee"
                        placeholder="เลือกพนักงาน"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :show-labels="false"
                        :customLabel="employeeLabel"
                        track-by="id">
                </multiselect>
            </b-col>
        </div>
        <div class="col text-center">
            <button type="button"
                    @click="submitRentalFee"
                    class="btn btn-success">
                <icon name="save"></icon>
                บันทึก</button>&nbsp;&nbsp;
            <button type="button"
                    @click="cancelRentalFee"
                    class="btn btn-outline-secondary">
                <icon name="times"></icon> ยกเลิก
            </button>
        </div>
<!--        <pre class="alert-success">{{form}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex"
    import moment from "moment"
    import Multiselect from "vue-multiselect"

    export default {
        name: "rental-fee-modal",
        components:{Multiselect},
        created(){
            this.$store.dispatch("Employee/getEmployeeAll").then(res=>{
                this.optionEmployee = res;
            })
        },
        data(){
          return{
              optionEmployee : [],
          }
        },
        computed:{
            ...mapState({
                form:state=>{
                    return state.RentalFee.rentalFeeForm;
                },
            })

        },
        methods:{
            employeeLabel(option){
                return `${option.employee_no} - ${option.name}`
            },
            submitRentalFee() {
                if (this.form.employee.length > 0) {
                    this.form.employee_id = []
                    this.form.employee.forEach(data=>{
                        this.form.employee_id.push(data.id)
                    })
                }else if(this.form.employee.length  == 0){
                    this.form.employee_id = [];
                }

                let dataRental ={
                    id: this.form.id,
                    rental_name : this.form.rental_name,
                    count : this.form.count,
                    rent_price : this.form.rent_price,
                    bill : this.form.bill,
                    water_price : this.form.water_price,
                    employee_id : this.form.employee_id.toString(),
                }
                this.$emit("submit",dataRental)
            },
            cancelRentalFee(){
                this.$emit("submit",0)
            }
        }
    }
</script>

<style scoped>

</style>
